/** localStorage: recente AAL2-sessie (gedeeld tussen tabbladen voor view-as). */
const MFA_SESSION_BRIDGE_KEY = 'sa_mfa_session_bridge'
const MFA_SESSION_BRIDGE_TTL_MS = 5 * 60 * 1000

function readStorage (): Storage | null {
  if (typeof localStorage === 'undefined') return null
  return localStorage
}

export function markMfaSessionBridge (): void {
  const storage = readStorage()
  if (!storage) return
  try {
    storage.setItem(MFA_SESSION_BRIDGE_KEY, String(Date.now()))
  } catch {
    /* private mode / quota */
  }
}

export function hasFreshMfaSessionBridge (): boolean {
  const storage = readStorage()
  if (!storage) return false

  try {
    const raw = storage.getItem(MFA_SESSION_BRIDGE_KEY)
    if (!raw) return false

    const markedAt = Number.parseInt(raw, 10)
    if (!Number.isFinite(markedAt)) {
      storage.removeItem(MFA_SESSION_BRIDGE_KEY)
      return false
    }

    if (Date.now() - markedAt > MFA_SESSION_BRIDGE_TTL_MS) {
      storage.removeItem(MFA_SESSION_BRIDGE_KEY)
      return false
    }

    return true
  } catch {
    return false
  }
}

/** Superadmin "Bekijk als" klantportaal-routes (buiten SuperadminLayout). */
export function isImpersonationViewPath (pathname: string): boolean {
  return /^\/superadmin\/users\/[^/]+\/klant(?:\/|$)/.test(pathname)
}
